import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { NewSavingsAccountService, SavingsAccount, SavingsAccountState } from '@brightside-web/desktop/feature/savings-account';

@Component({
    selector: 'brightside-web-savings-tax-statements',
    templateUrl: './savings-tax-statements.component.html',
    styleUrls: ['./savings-tax-statements.component.scss'],
    standalone: false
})
export class SavingsTaxStatementsComponent {
  currentAccountInfo$: Observable<SavingsAccountState> = this._savingsSvc.currentAccountInfo;

  constructor(private _savingsSvc: NewSavingsAccountService) {}

  ngOnInit(): void {
    this._savingsSvc.getSavingsAccounts();
  }
}
